import { ReactNode } from 'react';
import ivclass from '@invideoio/web-shared/Modules/IVClass';

import Facebook from '@components/social-media-links/facebook';
import Linkedin from '@components/social-media-links/linkedin';
import Twitter from '@components/social-media-links/twitter';

interface ShareOptionsWrapperPropType {
  postTitle: string;
  postUrl: string;
  visibleAtTop?: boolean;
}
const ShareOptionsWrapper = ({
  postUrl,
  postTitle,
  visibleAtTop,
}: ShareOptionsWrapperPropType) => {
  return (
    <div className={ivclass('iv-flex iv-gap-7')}>
      <Twitter
        postTitle={postTitle}
        postUrl={postUrl}
        visibleAtTop={visibleAtTop}
      />
      <Facebook postUrl={postUrl} visibleAtTop={visibleAtTop} />
      <Linkedin
        postTitle={postTitle}
        postUrl={postUrl}
        visibleAtTop={visibleAtTop}
      />
    </div>
  );
};

export default ShareOptionsWrapper;
